import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { EffectsContainer } from 'mixins/withEffects';
import TopicCommentFilterVM, { TopicCommentsFilterVMConfig } from './filter';
import './textFilter.html';

export interface TopicCommentsFiltersVMTextFilterConfig extends TopicCommentsFilterVMConfig<string> {
    placeholder: SubscribableOrNullableValue<string>
}

@injectable()
export default class TopicCommentsFiltersVMTextFilterVM extends TopicCommentFilterVM<string> {
    placeholder: Subscribable<string | undefined>

    constructor(
        @inject(wccModules.componentConfig) config: TopicCommentsFiltersVMTextFilterConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        super(config, info, effects, '');

        this.placeholder = ko.flattenComputed(config.placeholder);        

        ko.applyBindingsToNode(info.element, {
            'css': {
                'topic-comments-filters__text-filter': true
            }
        });
    }
}